import script from "./SuggestFeed.vue?vue&type=script&setup=true&lang=js"
export * from "./SuggestFeed.vue?vue&type=script&setup=true&lang=js"

import "./SuggestFeed.vue?vue&type=style&index=0&id=3670f48a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3670f48a"]])

export default __exports__